module.exports = __webpack_public_path__ + "img/foto-escritorio-3.1b21d4bb.png";